import { render, staticRenderFns } from "./PhotoInputArea.vue?vue&type=template&id=2887398b&scoped=true"
import script from "./PhotoInputArea.vue?vue&type=script&lang=js"
export * from "./PhotoInputArea.vue?vue&type=script&lang=js"
import style0 from "./PhotoInputArea.vue?vue&type=style&index=0&id=2887398b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887398b",
  null
  
)

export default component.exports